import { Link } from 'react-router-dom';
import type { Video } from '@/mocks/videos';
import { formatDuration, formatViews } from '@/utils/format';

interface PopularSidebarProps {
  videos: Video[];
}

export default function PopularSidebar({ videos }: PopularSidebarProps) {
  return (
    <aside className="bg-background-100 border border-background-200 rounded-lg p-4 md:p-5">
      <div className="flex items-center gap-2 pb-4 mb-4 border-b border-background-200">
        <span className="w-8 h-8 flex items-center justify-center rounded-md bg-accent-500/15 text-accent-400 text-lg">
          <i className="ri-fire-line"></i>
        </span>
        <h2 className="font-heading text-base md:text-lg font-bold text-foreground-950">热门推荐</h2>
      </div>

      <ol className="space-y-3.5">
        {videos.map((v, i) => (
          <li key={v.id}>
            <Link to={`/detail/${v.id}`} className="group flex items-center gap-3">
              <span
                className={`w-6 shrink-0 text-center font-heading text-base font-extrabold ${
                  i < 3 ? 'text-primary-400' : 'text-foreground-500'
                }`}
              >
                {i + 1}
              </span>
              <span className="relative w-24 h-14 md:w-28 md:h-16 shrink-0 rounded-md overflow-hidden bg-background-200">
                <img src={v.cover} alt={v.title} title={`${v.title} - 靠逼视频`} className="w-full h-full object-cover object-top" />
                <span className="absolute bottom-1 right-1 px-1.5 py-0.5 rounded bg-background-950/80 text-[10px] text-foreground-950">
                  {formatDuration(v.duration)}
                </span>
              </span>
              <span className="min-w-0">
                <span className="block text-sm font-medium text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-400 transition-colors">
                  {v.title}
                </span>
                <span className="mt-1 block text-xs text-foreground-600">
                  <i className="ri-eye-line mr-1"></i>
                  {formatViews(v.views)}
                </span>
              </span>
            </Link>
          </li>
        ))}
      </ol>
    </aside>
  );
}